// import classNames from 'classnames';
import classNames from 'classnames';
import useSetBookmark from 'utilities/hooks/bookmark/useSetBookmark';
import useSetShareButtons from 'utilities/hooks/share/useSetShareButtons';
import {useLocalStorage} from 'utilities/hooks/useLocalStorage';

const Header = ({post}: IHeaderComponentProps) => {
  const [bookmarks, setBookmarks] = useLocalStorage('bookmarks', []);
  const {handleBookMark} = useSetBookmark();
  const {handleShareButton} = useSetShareButtons();
  return (
    <>
      <div className="w-full flex justify-end">
        <i className="icon-Comparison text-lg  text-primary mx-2" />
        <span
          className="icon-share text-primary mx-2  text-lg"
          onClick={() => handleShareButton(post)}
        ></span>
        {bookmarks && (
          <i
            className={
              classNames(bookmarks?.find(x => x?.guid === post?.guid))
                ? 'icon-bookmark-active text-primary mx-2 text-lg'
                : 'icon-bookmark-ads text-primary mx-2 text-lg'
            }
            onClick={() => handleBookMark(bookmarks, post, setBookmarks)}
          ></i>
        )}
      </div>
    </>
  );
};

export default Header;
